const enum RepetitionSpecialHolidayOptionType {
  ALLOW_SPECIAL_HOLIDAY = 'ALLOW_SPECIAL_HOLIDAY',
  MOVE_FORWARD = 'MOVE_FORWARD',
  MOVE_BACKWARD = 'MOVE_FORWARD',
  OMIT = 'OMIT',
}

export default RepetitionSpecialHolidayOptionType;
